export const studentScreenHelpUrl = 'https://support.esgisoftware.com/hc/en-us/articles/360034731971-Student-Screen';